import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { mapOpenedMapsSelector } from '@/redux/map/map.selectors';
import { openMapAndSetActive, setActiveMap } from '@/redux/map/map.slice';
import { modelsDataSelector } from '@/redux/models/models.selectors';
import { useCallback } from 'react';
import { closeDrawer } from '@/redux/drawer/drawer.slice';

type UseOpenSubmapProps = {
  modelId: number | undefined;
  modelName: string | undefined;
};

type UseOpenSubmapReturnType = {
  openSubmap: () => void;
  isItPossibleToOpenMap: boolean;
};

export const useOpenSubmap = ({
  modelId,
  modelName,
}: UseOpenSubmapProps): UseOpenSubmapReturnType => {
  const openedMaps = useAppSelector(mapOpenedMapsSelector);
  const models = useAppSelector(modelsDataSelector);
  const dispatch = useAppDispatch();

  const isMapAlreadyOpened = openedMaps.some(map => map.modelId === modelId);
  const isMapExist = models.some(model => model.id === modelId);
  const isItPossibleToOpenMap = modelId && modelName && isMapExist;

  const openSubmap = useCallback(() => {
    if (!isItPossibleToOpenMap) {
      return;
    }

    if (isMapAlreadyOpened) {
      dispatch(setActiveMap({ modelId }));
    } else {
      dispatch(openMapAndSetActive({ modelId, modelName }));
    }
    dispatch(closeDrawer());
  }, [dispatch, isItPossibleToOpenMap, isMapAlreadyOpened, modelId, modelName]);

  return { openSubmap, isItPossibleToOpenMap: Boolean(isItPossibleToOpenMap) };
};
